import { useQuery } from '@tanstack/react-query';
import {
  RecipientBankAccountService,
  RecipientBankListEntity,
} from 'services/openapi';

import { RecipientBankAccountQueryKeys } from '../constants';

export const useGetListBanksQuery = () => {
  const queryKey = [RecipientBankAccountQueryKeys.GET_BANKS];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<RecipientBankListEntity, Error>({
    queryKey,
    queryFn: () =>
      RecipientBankAccountService.recipientBankAccountControllerGetBanks(),
    retry: 0,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
